/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useState} from 'react';
import DisplayIcon from "../components/Icons/DisplayIcon.jsx";
import ElementStatus from "../components/ElementStatus.jsx";
import DisplayPlannedConfig from "../components/DisplayPlannedConfig.jsx";
import DisplayNodeConfig from "../components/DisplayNodeConfig.jsx";
import DisplayNodeState from "../components/DisplayNodeState.jsx";
import DisplayCommand from "../components/DisplayCommand.jsx";
import ButtonComponent from "../components/BasicInputs/ButtonComponent.jsx";
import DisplayStateHistory from "../components/DisplayStateHistory.jsx";
import DisplayNodeInstallLog from "../components/DisplayNodeInstallLog.jsx";
import NodeCharts from "../components/Node/NodeCharts.jsx";
import Tabs from "../components/Tabs/Tabs.jsx";
import Tab from "../components/Tabs/Tab.jsx";
import NodeLogs from "../components/Node/NodeLogs.jsx";
import Strings from 'toolbox/strings';
import useBuildServer from "../hooks/useBuildServer.jsx";
import BuildServerSettings from "../components/BuildServer/BuildServerSettings.jsx";
import BuildServerLogs from "../components/BuildServer/BuildServerLogs.jsx";

const BuildServerPage = ({buildServerId}) => {
    const [currentTab, setCurrentTab] = useState(0)
    const nodeInfo = useBuildServer(buildServerId)
    const isLoaded = !Strings.isEmpty(nodeInfo.indexKey)

    function openNodeURL() {
        window.open("http://" + nodeInfo.buildServerDomain, '_blank', 'noopener,noreferrer')
    }

    if (!isLoaded) {
        return (<div>Loading build server info. {buildServerId}</div>)
    }

    return (
        <div>

            <div className=" bg-white rounded-2xl my-3 p-5">
                <div className="mx-auto flex items-center justify-between gap-x-8 lg:mx-0">
                    <div className="flex items-center gap-x-6">
                        <div
                            className={"h-16 w-16 flex-none rounded-full ring-1 ring-gray-900/10 flex justify-center items-center z-30"}>
                            <DisplayIcon iconName={"Node"} className={"h-7 w-7"}/>

                        </div>

                        <h1>
                            <div
                                className="text-sm leading-6 text-gray-500">{nodeInfo?.buildServerDomain ?? "[Not Set]"}</div>
                            <div
                                className="mt-1 text-base font-semibold leading-6 text-gray-900">{nodeInfo?.name ?? "[Not Set]"}</div>
                        </h1>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <ElementStatus name={"BuildServers"} elementId={nodeInfo?.indexKey}/>
                    </div>
                </div>
                <div className="flex items-center gap-x-3 pt-4">

                    <ButtonComponent
                        text={"Open Node URL"}
                        iconName={"IoEyeOutline"}
                        onClick={() => {
                            return openNodeURL()
                        }}/>


                </div>

            </div>
            <Tabs activeKey={currentTab}
                  onSelect={(number) => setCurrentTab(number)} variant={'default'} isBox>
                <Tab eventKey={0} title={"Übersicht"}>
                    <NodeLogs nodeId={nodeInfo.indexKey}/>
                </Tab>
                <Tab eventKey={1} title={"State"}>
                    <DisplayStateHistory name={"BuildServers"} elementId={nodeInfo.indexKey}/>

                </Tab>
                <Tab eventKey={2} title={"Logs"}>
                    <BuildServerLogs buildServerId={nodeInfo.indexKey}/>

                </Tab>

                <Tab eventKey={3} title={"Einstellungen"}>

                    <BuildServerSettings buildServerId={nodeInfo.indexKey}/>

                </Tab>

                <Tab eventKey={4} title={"Resources"}>
                    <NodeCharts nodeId={nodeInfo.indexKey}/>

                </Tab>
                <Tab eventKey={5} title={"DEV"}>
                    <div className={"space-y-3"}>
                        <DisplayPlannedConfig nodeId={nodeInfo.indexKey}/>
                        <DisplayNodeConfig nodeId={nodeInfo.indexKey}/>
                        <DisplayNodeState nodeId={nodeInfo.indexKey}/>
                        <DisplayNodeInstallLog nodeId={nodeInfo.indexKey}/>

                        <DisplayCommand
                            command={`ssh -t -o StrictHostKeyChecking=no 'root@${nodeInfo.nodeIP}' -p 22 'cd "/home"; screen -ls; docker container list; eval "$SHELL -il"'`}/>
                    </div>

                </Tab>
            </Tabs>


        </div>
    );
}

BuildServerPage.propTypes = {};

BuildServerPage.defaultProps = {};


export default BuildServerPage;